import React from "react";
import { Phone, Calendar, MessageCircle, MapPin } from "lucide-react";
import { CLINIC } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export default function FloatingActions({ onBookClick }) {
  const { t } = useLang();
  return (
    <>
      <a
        href={`https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent("Hello! I'd like to book an appointment at Shri Anandpur Trust Diagnostic Centre.")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-5 bottom-24 lg:bottom-8 z-40 bg-wa text-white p-4 rounded-full shadow-lifted hover:scale-110 transition-transform animate-pulse-ring"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-float"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={2} />
      </a>

      <button
        onClick={onBookClick}
        className="hidden lg:flex fixed top-1/2 -translate-y-1/2 right-0 z-40 items-center gap-2 bg-gold text-deep py-3 px-5 rounded-l-2xl shadow-lifted hover:px-6 transition-all font-semibold text-sm"
        data-testid="sticky-book-btn"
      >
        <Calendar className="w-4 h-4" /> {t("cta.book")}
      </button>

      <div
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-black/5 shadow-[0_-10px_30px_rgba(0,0,0,0.06)] grid grid-cols-4 gap-1 p-2"
        data-testid="mobile-action-bar"
      >
        <a href={`tel:${CLINIC.phone}`} className="flex flex-col items-center justify-center py-2 text-deep text-[11px] font-semibold" data-testid="mobile-fab-call">
          <Phone className="w-5 h-5 mb-1 text-brand" strokeWidth={1.7} /> {t("cta.call").split(" ")[0]}
        </a>
        <button onClick={onBookClick} className="flex flex-col items-center justify-center py-2 text-deep text-[11px] font-semibold" data-testid="mobile-fab-book">
          <Calendar className="w-5 h-5 mb-1 text-brand" strokeWidth={1.7} /> {t("cta.book").split(" ")[0]}
        </button>
        <a href={`https://wa.me/${CLINIC.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center py-2 text-deep text-[11px] font-semibold" data-testid="mobile-fab-wa">
          <MessageCircle className="w-5 h-5 mb-1 text-wa" strokeWidth={1.7} /> WhatsApp
        </a>
        <a
          href="https://maps.google.com/?q=Krishna+Nagar+Delhi+Shri+Anandpur+Trust"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-2 text-deep text-[11px] font-semibold"
          data-testid="mobile-fab-map"
        >
          <MapPin className="w-5 h-5 mb-1 text-gold" strokeWidth={1.7} /> Map
        </a>
      </div>
    </>
  );
}
